import React from "react";
import {
  Grid,
  Box,
  Link,
  Typography,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import Image from "../Image";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { COLORS } from "../../constants";

const MobileSiteFooter = ({ contactInfo, socialLinks, sections }) => (
  <Grid item xs={12} sx={{}}>
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        color: COLORS.white,
      }}
    >
      {/* Logo */}
      <Image
        href="/"
        src="https://argusweb.azureedge.net/argus-web/logo.svg"
        alt="Logo"
        size={"xl"}
        sx={{ marginBottom: "1rem", p: 2 }}
      />

      {/* Location */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          marginBottom: "0.75rem",
          px: 2,
          py: 1,
        }}
      >
        <LocationOnIcon
          sx={{ fontSize: "1rem", marginRight: "0.5rem", marginTop: "0.1rem" }}
        />
        <Typography
          variant="caption"
          sx={{
            lineHeight: "1.5",
            whiteSpace: "pre-line",
            fontWeight: "200",
            fontSize: "var(--font-size-xxs)",
          }}
        >
          {contactInfo.address}
        </Typography>
      </Box>

      {/* Phone */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          marginBottom: "0.75rem",
          px: 2,
          py: 1,
        }}
      >
        <PhoneIcon
          sx={{ fontSize: "1rem", marginRight: "0.5rem", marginTop: "0.1rem" }}
        />
        <Typography
          variant="caption"
          sx={{ lineHeight: "1.5", whiteSpace: "pre-line", fontWeight: "200" }}
        >
          {contactInfo.phone}
        </Typography>
      </Box>

      {/* Email */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          marginBottom: "0.75rem",
          px: 2,
          py: 1,
        }}
      >
        <EmailIcon
          sx={{ fontSize: "1rem", marginRight: "0.5rem", marginTop: "0.1rem" }}
        />
        <Typography
          variant="caption"
          sx={{ lineHeight: "1.5", fontWeight: "200" }}
        >
          {contactInfo.email}
        </Typography>
      </Box>

      {/* Follow Us */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginBottom: "1rem",
          p: 2,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            marginBottom: "1rem",
            fontWeight: "400",
            textTransform: "uppercase",
          }}
        >
          Follow Us
        </Typography>
        <Box sx={{ display: "flex", gap: "0.5rem" }}>
          {socialLinks.map((social, index) => (
            <IconButton
              key={index}
              href={social.href}
              sx={{ padding: 0, color: COLORS.white }}
            >
              {social.icon}
            </IconButton>
          ))}
        </Box>
      </Box>

      {/* Accordion Sections */}
      {sections.map((section, index) => (
        <Accordion
          key={index}
          sx={{
            width: "100%",
            backgroundColor: `${COLORS.themeBlack} !important`,
            color: COLORS.white,
            boxShadow: "none",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: COLORS.white }} />}
          >
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: "400", textTransform: "uppercase" }}
            >
              {section.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              {section.links.map((link, linkIndex) => (
                <Link
                  key={linkIndex}
                  href={link.href}
                  color={COLORS.lightGray}
                  underline="hover"
                  variant="caption"
                  sx={{
                    marginBottom:
                      linkIndex < section.links.length - 1 ? "0.5rem" : 0,
                    display: "block",
                    fontWeight: "200",
                  }}
                >
                  {link.label}
                </Link>
              ))}
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  </Grid>
);

export default MobileSiteFooter;
